import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["grid", "list", "gridBtn", "listBtn"]

    declare readonly gridTarget: HTMLElement
    declare readonly listTarget: HTMLElement
    declare readonly gridBtnTarget: HTMLElement
    declare readonly listBtnTarget: HTMLElement
    declare readonly hasGridTarget: boolean
    declare readonly hasListTarget: boolean
    declare readonly hasGridBtnTarget: boolean
    declare readonly hasListBtnTarget: boolean

    connect() {
        // FIXME: Remove this alert after confirming functionality
        // alert("View Mode Controller Connected!")
        console.log("DisplayModeController connected")
        if (!this.hasGridTarget || !this.hasListTarget) {
            console.warn("DisplayModeController: Grid or List target missing")
            return
        }

        // Check if buttons exist (they might not if no robots)
        if (!this.hasGridBtnTarget || !this.hasListBtnTarget) {
            console.warn("DisplayModeController: Toggle buttons missing")
        }

        const savedMode = localStorage.getItem("adminRobotsViewMode") || "grid"
        this.setMode(savedMode)
    }

    showGrid() {
        console.log("showGrid clicked")
        this.setMode("grid")
    }

    showList() {
        console.log("showList clicked")
        this.setMode("list")
    }

    private setMode(mode: string) {
        if (!this.hasGridTarget || !this.hasListTarget) return

        if (mode === "grid") {
            this.gridTarget.classList.remove("hidden")
            this.listTarget.classList.add("hidden")

            if (this.hasGridBtnTarget) {
                this.gridBtnTarget.classList.add("bg-indigo-100", "text-indigo-600")
                this.gridBtnTarget.classList.remove("text-slate-500", "hover:text-slate-700")
            }

            if (this.hasListBtnTarget) {
                this.listBtnTarget.classList.remove("bg-indigo-100", "text-indigo-600")
                this.listBtnTarget.classList.add("text-slate-500", "hover:text-slate-700")
            }
        } else {
            this.gridTarget.classList.add("hidden")
            this.listTarget.classList.remove("hidden")

            if (this.hasListBtnTarget) {
                this.listBtnTarget.classList.add("bg-indigo-100", "text-indigo-600")
                this.listBtnTarget.classList.remove("text-slate-500", "hover:text-slate-700")
            }

            if (this.hasGridBtnTarget) {
                this.gridBtnTarget.classList.remove("bg-indigo-100", "text-indigo-600")
                this.gridBtnTarget.classList.add("text-slate-500", "hover:text-slate-700")
            }
        }

        localStorage.setItem("adminRobotsViewMode", mode)
    }
}
